import { format, parse } from 'date-fns';

const EMPTY_VALUE = '';
const DATE_FORMAT = 'MM/DD/YYYY';

export default function formatDate(value, f = DATE_FORMAT, emptyValue = EMPTY_VALUE) {
  if (!value) return emptyValue;

  if (typeof f === 'string') {
    /* eslint-disable-next-line no-param-reassign */
    f = {
      in: DATE_FORMAT,
      out: f,
    };
  }

  /* eslint-disable-next-line no-param-reassign */
  if (!f.out) f.out = DATE_FORMAT;

  if (value instanceof Date) {
    return format(value, f.out);
  }

  return format(parse(value, f.in, new Date()), f.out);
}
